import { typographyHelper, paletteHelper, H1, Stack, Text } from '@property.com.au/ui-kit';
import { FunctionComponent } from 'react';
import styled from 'styled-components';
import { minHeightWhenNoContent } from '../../app-kit/helpers/minHeightWhenNoContent';

const Overline = styled(Text)`
  ${typographyHelper('overline')};
  color: ${paletteHelper('textSecondary')};
  ${minHeightWhenNoContent}
`;

const Title = styled(H1)`
  ${typographyHelper('title03')};
  margin-bottom: 0;
  ${minHeightWhenNoContent}
`;

const Subtitle = styled(Text)`
  ${typographyHelper('title03Light')};
  color: ${paletteHelper('textSecondary')};
  font-size: 0.875rem; /* Design uses title03Light with sizing from subtitle02 */
  line-height: 100%;
  ${minHeightWhenNoContent}
`;

interface HeaderTitleProps {
  overline: string | null;
  title: string;
  subtitle: string;
}
export const HeaderTitle: FunctionComponent<HeaderTitleProps> = ({ overline, title, subtitle }) => {
  return (
    <Stack gap="twoExtraSmall">
      {overline && <Overline>{overline}</Overline>}
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
    </Stack>
  );
};
